export class InitialTimeResponse {
    /**
     * Wrap the raw response of a timeframe.
     *
     * @param initTimes with parameter and init_date
     */
    constructor(initTimes) {
        this.initTimes = initTimes;
    }
    /**
     * Parse a CSV API response
     *
     * @param txt
     */
    static parseFromCsv(txt) {
        const format = txt
            .split("\n")
            .filter((l) => l.trim() !== "")
            .map((line, lineNumber) => ({ line, lineNumber }));
        const header = format.shift();
        const firstLine = format.shift();
        const array = [];
        if (header && firstLine) {
            const parameters = header?.line.split(";");
            parameters?.shift();
            const initTimes = firstLine?.line.split(";");
            initTimes?.shift();
            parameters.forEach((element, index) => {
                array.push({
                    parameter: element,
                    initTime: initTimes[index],
                });
            });
        }
        else {
            throw Error(`Not a valid CSV`);
        }
        return new InitialTimeResponse(array);
    }
    toTransferable() {
        return {
            initTimes: this.initTimes,
        };
    }
    static fromTransferable(v) {
        return new InitialTimeResponse(v.initTimes);
    }
}
//# sourceMappingURL=InitialTimeResponse.js.map